import { Link } from '@blaze-cms/nextjs-components';
import { FaFacebookF, FaXTwitter, FaInstagram } from 'react-icons/fa6';

const SOCIAL_DATA = [
  {
    href: 'https://www.facebook.com/DockwalkMagazine/',
    name: 'facebook',
    socialClass: 'facebook-f',
    Icon: FaFacebookF
  },
  {
    href: 'https://twitter.com/Dockwalk/',
    name: 'twitter',
    socialClass: 'twitter',
    Icon: FaXTwitter
  },
  {
    href: 'https://www.instagram.com/dockwalk/',
    name: 'instagram',
    socialClass: 'instagram',
    Icon: FaInstagram
  }
];

const SocialFollow = () => (
  <div className="social social--follow">
    <ul className="social__list social__list--follow">
      {SOCIAL_DATA.map(({ href, name, Icon }) => (
        <li key={name} className="social__list-item social__list-item--follow">
          <Link href={href} className={name}>
            <i>
              <Icon />
            </i>
            <span className="hidden">{name}</span>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default SocialFollow;
